import { Box } from '@quintoandar-tokko/jopijs';
import styles from './dndList.module.scss';
import getCardRenderConfig from './utils';

function DragOverlayCard({ item, tabId, sectionId }) {
  if (!item) return null;

  const { Component: OverlayComponent, props } = getCardRenderConfig({
    tabId,
    sectionId,
    item,
  });
  if (!OverlayComponent) return null;

  return (
    <Box className={styles.dragOverlay}>
      <OverlayComponent {...props} />
    </Box>
  );
}

export default DragOverlayCard;
